var _circle, _rect, _rect2, _path, _rect3, _path2, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _rect7, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 240,
    viewBox: "0 0 241 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 120,
    r: 120,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120.787,
    height: 18.0777,
    rx: 2.01392,
    transform: "matrix(1 0 0 -1 60.5699 174.115)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 121.875,
    height: 18.7759,
    rx: 2.01392,
    transform: "matrix(1 0 0 -1 60.0625 175.288)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5699 67.5445C60.5699 65.0748 62.572 63.0727 65.0417 63.0727H177.466C179.935 63.0727 181.938 65.0748 181.938 67.5444V149.033C181.938 150.146 181.036 151.047 179.924 151.047H62.5839C61.4716 151.047 60.5699 150.146 60.5699 149.033V67.5445Z",
    fill: "#18223D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.9917,
    y: 67.2099,
    width: 112.524,
    height: 79.7003,
    rx: 2.01392,
    fill: "#EBEEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2656 73.7244C68.2656 72.1355 69.5537 70.8474 71.1427 70.8474H133.357C134.946 70.8474 136.234 72.1355 136.234 73.7244V140.992C136.234 141.787 135.59 142.431 134.796 142.431H69.7041C68.9097 142.431 68.2656 141.787 68.2656 140.992V73.7244Z",
    fill: "#F5F6FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.2388,
    y: 150.379,
    width: 20.9478,
    height: 2.73569,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 135.443,
    y: 149.957,
    width: 18.8684,
    height: 2.46413,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 120.787,
    height: 18.0777,
    rx: 2.01392,
    transform: "matrix(1 0 0 -1 60.5699 170.499)",
    fill: "#18223D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.19 74.224C140.19 72.6351 141.478 71.347 143.067 71.347H172.843C174.432 71.347 175.72 72.6351 175.72 74.224V140.933C175.72 141.727 175.076 142.371 174.282 142.371H141.628C140.834 142.371 140.19 141.727 140.19 140.933V74.224Z",
    fill: "#F5F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.953 96.8076H165.953",
    stroke: "#18223D",
    strokeWidth: 4.02784,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.953 104.863H165.953",
    stroke: "#18223D",
    strokeWidth: 4.02784,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.953 112.919H165.953",
    stroke: "#18223D",
    strokeWidth: 4.02784,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.725 83.1691C155.725 85.6388 153.723 87.6409 151.253 87.6409C148.783 87.6409 146.781 85.6388 146.781 83.1691C146.781 80.6995 148.783 78.6974 151.253 78.6974C153.723 78.6974 155.725 80.6995 155.725 83.1691Z",
    fill: "url(#paint0_linear_194_3580)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.37 83.1691H159.753",
    stroke: "black",
    strokeWidth: 2.87703,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 145.609,
    y: 128.349,
    width: 25.7812,
    height: 9.38797,
    rx: 4.69398,
    fill: "url(#paint1_linear_194_3580)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.2188,
    y: 170.594,
    width: 30.4688,
    height: 2.34699,
    fill: "#18223D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 74.125,
    y: 76.7148,
    width: 57.4219,
    height: 31.6844,
    rx: 2,
    fill: "#99C8FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_3580",
    x1: 147.154,
    y1: 79.9391,
    x2: 157.94,
    y2: 85.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_3580",
    x1: 163.325,
    y1: 135.442,
    x2: 160.104,
    y2: 125.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.fdb7b9c8bc6472cb68708f4068b9d8ee.svg";
export { ForwardRef as ReactComponent };